import { render, staticRenderFns } from "./pharmacy_list2.vue?vue&type=template&id=f808c668&scoped=true&"
import script from "./pharmacy_list2.vue?vue&type=script&lang=js&"
export * from "./pharmacy_list2.vue?vue&type=script&lang=js&"
import style0 from "./pharmacy_list2.vue?vue&type=style&index=0&id=f808c668&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f808c668",
  null
  
)

export default component.exports